<template>
  <modal
    class="createAssetGroup"
    name="addAssetFile"
    transition="pop-out"
    :width="800"
    :height="300"
    @opened="opened"
    @closed="closed"
  >
    <div class="text-center assets_modal_div branch_assets_modal">
      <img
        src="@/assets/img/cancel-button.svg"
        class="close_assets_modal"
        @click="closeModal"
      />
      <p class="asset_modal_title">{{ $t("text.assets.addAssetFile") }}</p>
      <form>
        <div class="modal_form_field bas">
          <label class="assets_label">{{ $t("text.assets.documents") }}</label>
          <b-form-file
            multiple
            no-traverse
            v-model="documents"
            :state="Boolean(documents)"
            placeholder="Upload documents"
            accept="image/jpeg, image/png, image/gif"
          >
          </b-form-file>
        </div>
        <button
          @click="createAsset($event)"
          class="assets_button bas"
          :disabled="isButtonDisabled ? true : null"
          :style="[
            isButtonDisabled
              ? { cursor: 'not-allowed' }
              : { cursor: 'pointer' },
          ]"
        >
          {{ $t("text.assets.uploadDoc") }}
          <img
            src="@/assets/img/git_loader.gif"
            style="display: none"
            width="20px"
            class="ml-3 loader"
          />
        </button>
      </form>
    </div>
  </modal>
</template>
<script>
const MODAL_WIDTH = 1080;
import configObject from "@/config";

export default {
  name: "addAssetFile",
  props: ["id"],
  data() {
    return {
      modalWidth: MODAL_WIDTH,
      isButtonDisabled: false,
      showLoader: false,
      documents: [],
    };
  },
  created() {
    this.modalWidth =
      window.innerWidth < MODAL_WIDTH ? MODAL_WIDTH / 2 : MODAL_WIDTH;
  },

  mounted() {},
  methods: {
    opened() {
      //   this.getGroups()
    },
    closed() {
      this.documents = [];
    },
    toggleCheck() {
      this.isServicable = !this.isServicable;
    },
    toggleRenewalCheck() {
      this.isRenewable = !this.isRenewable;
    },
    closeModal() {
      this.$modal.hide("addAssetFile");
    },
    createAsset(e) {
      e.preventDefault();
      if (this.documents.length < 1 || !this.documents) {
        this.$toast.open({
          message: this.$t("text.assets.selectDoc"),
          type: "error",
          duration: 5000,
        });
        return;
      }

      let formData = new FormData();
      let documents = this.documents.forEach((el) => {
        formData.append("Documents", el);
      });

      this.isButtonDisabled = true;
      $(".loader").show();
      this.axios
        .post(
          `${configObject.apiBaseUrl}/Assets/${this.id}/add-asset-file`,
          formData,
          configObject.authConfigForUpload()
        )
        .then(() => {
          this.$toast.open({
            message: this.$t("text.assets.successfullyAddedAssetFile"),
            type: "success",
            duration: 5000,
          });

          $(".loader").hide();
          this.isButtonDisabled = false;
          this.$eventHub.$emit("refreshBranchAssets");
          this.closeModal();
        })
        .catch(() => {
          this.isButtonDisabled = false;
          $(".loader").hide();
        });
    },
  },
};
</script>
